<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Grievance Redressal Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Grievance Redressal Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Name of the member</th>
                <th>Role in Committee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Dr. Suresh Dharane</td>
                <td>Chairman</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Prof.Prafulla Jadhav</td>
                <td>Teaching Representative</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Prof.Sarika Kulthe</td>
                <td>Teaching Representative</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Prof. Cheena Kabra</td>
                <td>Teaching Representative</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Mr. Kavit Mahale</td>
                <td>Student Representative(BBA(CA))</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Ms. Rutik Hargude</td>
                <td>Student Representative(B. Sc(CS))</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Mr. Himanshu Nag</td>
                <td>Student Representative(B.Com)</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Ms. Khushboo Gupta</td>
                <td>Student Representative(BBA)</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Mr.Sudarshan Diwate</td>
                <td>Non - Teaching Representative</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Mr. Kuldeep Paliwal</td>
                <td>Non - Teaching Representative</td>
              </tr>
            </tbody>
          </table>
          <!-- <table class="table table-bordered table-striped table--4">
                  <thead>
                    <tr>
                      <th>Sr.No.</th>
                      <th>Name of the member</th>
                      <th>Role in Committee</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Dr. Vijaya Gondane</td>
                      <td>Chairman</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Prof.Prafulla Jadhav</td>
                      <td>Teaching Representative</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Prof.Sarika Kulthe </td>
                      <td>Teaching Representative</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Prof. Cheena Kabra</td>
                      <td>Teaching Representative</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Mr. Dhananjay Patel</td>
                      <td>Student Representative(BBA(CA))</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Ms. Jidnyasa Athawale</td>
                      <td>Student Representative(B. Sc(CS))</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Mr.Nikhil Jagdale</td>
                      <td>Student Representative(B.Com)</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Ms. Gadekar Bharti Laxman</td>
                      <td>Student Representative(BBA)</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Mr.Sudarshan Diwate</td>
                      <td>Non – Teaching Representative</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Mr.Bhushan Vasant</td>
                      <td>Non – Teaching Representative</td>
                    </tr>
                  </tbody>
                </table> -->
        </div>
      </div>
    </div>
  </div>
</section>
